<template>
  <div class="order-detail">
    <div class="container">
      <div class="order-header">
        訂單詳情
      </div>
      <div class="order-main">
        <div>
          <p>
            <span class="label">買入賬戶：</span>
            <span>{{ departmentName }}</span>
          </p>
          <p>
            <span class="label">操作人：</span>
            <span>{{ accountName }}</span>
          </p>
          <p>
            <span class="label">創建時間：</span>
            <span style="margin-left: -4px"> {{ createTime | formatDate }}</span>
          </p>
          <p>
            <span class="label">訂單編號：</span>
            <span>{{ orderId }}</span>
          </p>
          <p>
            <span class="label">訂單詳情：</span>
            <span class="red">{{ itemWithCulture }}</span>
          </p>
          <p>
            <span class="label">訂單金額：</span>
            <span>{{ money }}</span>
          </p>
        </div>
        <div class="paybox">
          <div class="paybox_tit">
            付款方式
          </div>
          <div>
            <el-radio-group
              v-model="radiopay"
              class="paybox_radio"
              @change="changeradiopay"
            >
              <div
                v-for="item in payTypesradio"
                :key="item.id"
              >
                <el-radio :label="item.id">
                  <img
                    :src="item.imgsrc"
                    :class="[item.id, 'imgpay']"
                  >
                  <span class="paybox_desc">{{ item.desc }}</span>
                </el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="btns">
        <el-button
          class="pay-btn"
          type="danger"
          @click="pay"
        >
          立即付款
        </el-button>
        <!-- $router.go(-1) -->
        <el-button
          type="info"
          @click="payVisible = true"
        >
          取消
        </el-button>
      </div>
    </div>
    <el-dialog
      class="conPdia"
      width="30%"
      :visible.sync="confirmPay"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="false"
    >
      <div style="text-align: center">
        <img
          src="../../assets/dollarlink.gif"
          alt="##"
        >
      </div>
      <div style="text-align: center">
        即將轉換到第三方的付款頁面
      </div>
      <div style="text-align: center">
        <img
          src="../../assets/dollarello.gif"
          alt="##"
        >
      </div>
    </el-dialog>
    <!-- toOrderMan :close-on-click-modal="false"-->
    <el-dialog
      title="提示"
      :before-close="toOrderMan"
      :visible.sync="payVisible"
      width="400px"
    >
      <span>
        <i class="el-icon-warning" />
        {{ `您的訂單將於${this.expireTime}後到期，請即付款!` }}
      </span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <!-- payDagain -->
        <el-button
          type="primary"
          @click="stayPage"
        >立即付款</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :show-close="false"
      :visible.sync="payFailVis"
      width="400px"
    >
      <span>
        <i class="el-icon-warning" />
        付款不成功，請重新付款
      </span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="payFailVis = false"
        >我知道了</el-button>
      </span>
    </el-dialog>
    <div>
      <form
        ref="form"
        name="payForm"
        method="post"
        :action="urlPd"
      />
    </div>
  </div>
</template>
<script>
export default {
    name: 'OrderDetail',
    filters: {
        formatDate(val) {
            let day = new Date(val * 1000);
            let y = day.getFullYear();
            let m = day.getMonth() + 1;
            let d = day.getDate();
            let h = day.getHours();
            let minutes = day.getMinutes();
            let temp = '';
            if (h > 12) {
                temp = 'PM';
                h = h - 12;
            } else {
                h = h;
                temp = 'AM';
            }
            return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + (h < 10 ? '0' + h : h) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ' ' + temp;
        }
    },
    data() {
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('sheetNum不能为空'));
            } else if (!Number.isInteger(value)) {
                callback(new Error('请输入数字'));
            } else {
                callback();
            }
        };

        return {
            payVisible: false,
            payFailVis: false,
            payTyperadio: [
                { id: 'credit', isShow: true, imgsrc: require('@/assets/creditCardPAY.svg'), desc: '信用卡（VISA, Mastercard）' },
                { id: 'paypal', isShow: true, imgsrc: require('@/assets/paypalPAY.svg') },
                { id: 'ali', isShow: true, imgsrc: require('@/assets/alipayHK.svg'), desc: 'AlipayHK（只適用於已註冊的AlipayHK用戶）' },
                { id: 'wechat', isShow: true, imgsrc: require('@/assets/wechat-pay.svg'), desc: 'WeChat Pay HK （只適用於已註冊的WeChat Pay HK用戶）' },
                { id: 'transfer', isShow: true, imgsrc: require('@/assets/transferPAY.svg'), desc: '銀行轉賬（會在下一個工作天內處理完成）' }
            ],
            radiopay: 'credit',
            orderId: 0,
            departmentName: '',
            accountName: '',
            createTime: 0,
            itemWithCulture: '',
            money: 0,
            confirmPay: false,
            urlPd: '',
            paymentType: '',
            paytype: this.$route.query.paytype || '',
            expireTime: this.$route.query.expireTime || localStorage.getItem('saveExptime')
        };
    },
    computed: {
        payTypesradio: function () {
            return this.payTyperadio.filter(item => {
                return item.isShow;
            });
        }
    },

    created() {
        // this.orderId = this.$route.query.orderId;
        this.getOrderRecord();
        this.getCompanyConfig();
        if (this.$route.query.paymentType) {
            this.paymentType = this.$route.query.paymentType;
            this.radiopay = this.paymentType == 9 ? 'paypal':this.paymentType == 10 ? 'transfer' : this.paymentType == 4 ? 'credit' : this.paymentType == 5 ? 'ali' : 'wechat';
        }
    },
    destroyed() {
        window.removeEventListener('popstate', this.goBack, false);
    },
    mounted() {
        // 浏览器返回 未付款提示
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', this.goBack, false);
        }
        if (this.paytype) {
            if (this.paytype == 'fail') {
                this.payFailVis = true;
            }
            // if (this.paytype == 'cancel') {
            //     this.payVisible = true;
            // }
        }
    },
    methods: {
        stayPage() {
            this.payVisible = false;
            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.goBack, false);
            }
        },
        goBack() {
            this.payVisible = true;
        },
        toOrderMan() {
            this.$router.push('/order/index');
        },
        // payDagain() {
        //     this.payVisible = false;
        //     this.submitCre();
        // },
        getCompanyConfig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                if (res.data.code == 0 && res.data.result) {
                    const { result } = res.data;
                    this.$set(this.payTyperadio[3], 'isShow', result.isShowWechatPay);
                    this.$set(this.payTyperadio[2], 'isShow', result.isShowAliPay);
                }
            });
        },
        async submitCre() {
            let _this = this;
            await _this.axios
                .post(_this.pub.getApi().CreatePayDollarOrder, {
                    orderID: _this.orderId,
                    platformType: 'pc',
                    PaymentType: _this.radiopay == 'credit' ? 4 : _this.radiopay == 'ali' ? 5 : 6
                })
                .then(res => {
                    this.paycode = res.data.code;
                    if (res.data.code == 0) {
                        _this.urlPd = res.data.result;
                    } else {
                        _this.$message({
                            message: '訂單狀態不正確，請重試！',
                            type: 'warning',
                            showClose: true
                        });
                    }
                });
            this.confirmPay = true;
            setTimeout(() => {
                this.confirmPay = false;
                if (this.paycode == 0) {
                    _this.$refs.form.submit();
                }
            }, 3000);
        },
        changeradiopay() {
            console.log('radiopay', this.radiopay);
        },
        // 获取订单信息
        async getOrderRecord() {
            let res = await this.axios.get(this.pub.getApi().GetOrderRecord + `?orderId=${this.$route.query.orderId}`);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.orderId = result.orderID;
                this.departmentName = result.departmentName;
                this.accountName = result.accountName;
                this.createTime = result.createTime;
                this.itemWithCulture = result.itemWithCulture;
                this.money = 'HK$ ' + result.money.toLocaleString();
                this.expireTimeCulture = result.expireTimeCulture;
            }
        },
        // 支付
        pay() {
            localStorage.setItem('saveExptime', this.expireTimeCulture);
            if (this.radiopay == 'paypal' || this.radiopay == 'transfer') {
                this.$router.push({
                    path: '/coin/order-pay',
                    query: {
                        orderId: this.orderId,
                        backUrl: '/coin/index',
                        expireTime: this.expireTimeCulture,
                        payType: this.radiopay
                    }
                });
            } else {
                this.submitCre();
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/element-reset.less';
/deep/ .paybox_radio {
    div {
        margin-bottom: 17px;
    }
}
.conPdia {
    text-align: center;
    /deep/.el-dialog__header {
        display: none;
    }
}
/deep/ .el-radio__inner {
    width: 16px;
    height: 16px;
    border: 1px solid #b5b5be;
}
.order-detail {
    text-align: left;
    .container {
        // background-color: #fff;
        width: 100%;
    }
    .order-header {
        font-size: 24px;
        padding-bottom: 20px;
        color: #171725;
    }

    .order-main {
        font-size: 14px;
        padding: 20px 20px 24px 34px;
        background-color: #fff;
        border-radius: 10px;
        color: #696974;
        .paybox {
            margin-top: 20px;
            border-top: 1px solid#E2E2EA;
            .paybox_tit {
                margin-top: 20px;
                font-weight: 700;
                font-size: 14px;
                color: #171725;
                margin-bottom: 15px;
            }
            .paybox_radio {
                margin-bottom: 17px;
                .imgpay {
                    margin-left: 20px;
                    vertical-align: middle;
                }
                .credit {
                    width: 23px;
                    height: 18px;
                }
                .paypal {
                    width: 90px;
                    height: 20px;
                }
                .ali {
                    width: 20px;
                    height: 20px;
                }
                .wechat {
                    width: 21px;
                    height: 18px;
                }
                .transfer {
                    width: 22px;
                    height: 22px;
                }
                .paybox_desc {
                    font-size: 14px;
                    color: #444444;
                    margin-left: 18px;
                }
            }
        }
        p {
            line-height: 36px;
            .label {
                display: inline-block;
                width: 80px;
                // margin-right: 35px;
                color: #171725;
            }
            .red {
                color: #e50113;
            }
        }
    }
    .btns {
        border-top: 1px solid #f1f1f5;
        margin-top: 20px;
        text-align: left;
        .el-button {
            width: 88px;
            border-radius: 10px;
            height: 38px;
            &.pay-btn {
                width: 140px;
            }
        }
        .el-button ~ .el-button {
            margin-left: 15px;
        }
    }
}
</style>
